export enum LogoState {
	PREVIEW = 'preview',
	APPLIED = 'applied',
	DEFAULT = 'default'
}
